import { useQuery } from "@tanstack/react-query";
import { Activity, Download } from "lucide-react";
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid } from "recharts";
import { api } from "../lib/api";
import { Card } from "../components/ui/Card";
import { Button } from "../components/ui/Button";
import { Kpi } from "../components/ui/Kpi";

interface UsageData {
  kpis: { logins: number; uniqueUsers: number; avgSession: string; errors: number };
  trend: Array<{ day: string; count: number }>;
}

/** Usage Analytics (FR-016) — real KPIs and a real trend chart (Recharts,
 * as the approved prototype explicitly names for production), replacing
 * the legacy's "minimal analytics, no export/date filtering" pain point. */
export function Usage() {
  const { data } = useQuery({ queryKey: ["usage"], queryFn: () => api.get<UsageData>("/usage") });

  return (
    <div>
      <Card className="mb-5 p-4 flex items-center gap-2">
        <span className="font-semibold text-sm">Usage Analytics</span>
        <div className="ml-auto">
          <Button variant="outline" icon={Download} onClick={() => api.download("/usage/export", "Usage_Report.xlsx")}>
            Export
          </Button>
        </div>
      </Card>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-5">
        <Kpi label="Logins" value={data?.kpis.logins ?? "…"} sub="Last 30 days" icon={Activity} tone="blue" />
        <Kpi label="Unique Users" value={data?.kpis.uniqueUsers ?? "…"} sub="Last 30 days" icon={Activity} tone="blue" />
        <Kpi label="Avg Session" value={data?.kpis.avgSession ?? "…"} sub="Last 30 days" icon={Activity} tone="blue" />
        <Kpi label="Errors" value={data?.kpis.errors ?? "…"} sub="Last 30 days" icon={Activity} tone="blue" />
      </div>
      <Card className="p-5">
        <div className="text-xs font-semibold text-slate-500 mb-3">Login trend</div>
        <div style={{ height: 260 }}>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={data?.trend ?? []}>
              <CartesianGrid strokeDasharray="3 3" opacity={0.2} />
              <XAxis dataKey="day" fontSize={11} />
              <YAxis fontSize={11} />
              <Tooltip />
              <Line type="monotone" dataKey="count" stroke="#FFC72C" strokeWidth={2} dot={false} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </Card>
    </div>
  );
}
